import styled, { css } from "styled-components";
import { DialogTitle, DialogContent, IconButton } from "@material-ui/core";
import { DatePicker } from "@material-ui/pickers";
import { DateTimePicker } from "@material-ui/pickers";
import { ButtonsWrapper, lightBlack, primary } from "../Style/Style";

export const CloseButton = styled(IconButton)`
  position: absolute;
  top: 0;
  right: 0;
`;

export const DateRangeTitle = styled(DialogTitle)`
  text-transform: uppercase;
  text-align: center;
  color: ${lightBlack};

  & .MuiTypography-h6 {
    font-size: 16px;
  }
`;

export const DateRangeContent = styled(DialogContent)`
  display: flex;
  gap: 40px;
  text-align: center;
`;

export const DateRangeButtonsWrapper = styled(ButtonsWrapper)`
  margin: 0;
  padding: 20px;
  justify-content: space-between;
  gap: 12px;
`;

const dateInputStyles = css`
  & .MuiFormLabel-root.Mui-focused {
    color: ${primary};
  }

  & .MuiInput-underline {
    &:after {
      border-bottom-color: ${primary};
    }

    &:hover:not(.Mui-disabled):before {
      border-bottom-width: 1px;
    }
  }
`;

export const DateRangeInput = styled(DatePicker)`
  ${dateInputStyles}
`;

export const DateTimeRangeInput = styled(DateTimePicker)`
  ${dateInputStyles}
`;
